import { useDispatch } from 'react-redux'
import { updateEntry } from 'apps/builder/store/actions/entries'
import { useState } from 'react'

export const ClearAll = ({
  guid,
  style,
  maximum,
  setBoxFocus = () => {},
  setDisplayTypeMyOwnOptions = () => {},
}) => {
  const [showClearAllPrompt, setShowClearAllPrompt] = useState(false)
  const dispatch = useDispatch()

  const clearAll = () => {
    if (style != 5) {
      dispatch(
        updateEntry({
          guid,
          entry_values: [],
          default: 'GC_BLANK_DEFAULT',
          typeMyOwn: '',
        })
      )
    } else {
      const placeholderOptions = Array.from(
        Array(maximum),
        (element, index) => {
          return {
            placeholder: 'Type your choices here and press Enter',
            position: index,
          }
        }
      )

      dispatch(
        updateEntry({
          guid,
          entry_values: placeholderOptions,
          default: null,
          typeMyOwn: '',
        })
      )
    }
    setShowClearAllPrompt(false)
    setDisplayTypeMyOwnOptions('')
  }

  return showClearAllPrompt ? (
    <div className="clear-all-prompt--wrapper">
      <span>Are you sure you want to clear?</span>
      <div className={`clear--all-btn-group`}>
        <button
          className={`foundry--button button--outlined`}
          onClick={() => {
            setBoxFocus(false)
            setShowClearAllPrompt(false)
          }}
        >
          <span className="button--label">Cancel</span>
        </button>
        <button
          className={`foundry--button button--contained`}
          onClick={() => {
            setBoxFocus(false)
            clearAll()
          }}
        >
          <span className="button--label">Clear</span>
        </button>
      </div>
    </div>
  ) : (
    <div
      className="clear--all-wrapper"
      onClick={() => {
        setBoxFocus(true)
        setShowClearAllPrompt(true)
      }}
    >
      Clear All
    </div>
  )
}
